import { styled } from '../styles/styled'

const osDisclaimer = 'www.opensolar.com/proposal-disclaimer'

const StyledDisclaimer = styled('p')(({ theme }) => ({
  [theme.breakpoints.down('xs')]: {
    paddingBottom: 170,
  },
  fontSize: 10,
}))

export const getOpenSolarDisclosure = ({ orgName, translate }: { orgName?: string; translate }) => {
  const link = `<a href='https://${osDisclaimer}' target="_blank" rel="noreferrer">
      ${osDisclaimer}
    </a>`
  const msg = translate(
    'This proposal has been prepared by %{org} using tools from OpenSolar. Please visit %{link} for additional disclosures from OpenSolar.',
    { org: orgName || '', link }
  )

  return msg
}

export const OpenSolarDisclosure = ({ content }: { content?: string }) => {
  if (!content) return null
  return <StyledDisclaimer dangerouslySetInnerHTML={{ __html: content }} />
}
